import ErrorBoundary from "components/error/ErrorBoundary";
import { AuthCheckedState } from "global/AuthCheckedState";
import { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { LoginState } from "./global/LoginState";
import DashboardRoutes from "./routes/DashboardRoutes";
import LandingRoutes from "./routes/LandingRoutes";
import Alert from "./utils/Alert";
import Loader from "./utils/Loader";
import Tostify from "./utils/Tostify";
import TokenChecker from "./services/TokenChecker";

function App() {
  const [loginState] = useRecoilState(LoginState);
  const authChecked = useRecoilValue(AuthCheckedState);

  return (
    <BrowserRouter>
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <TokenChecker />
          <Loader />
          <Alert />
          {!authChecked
            ? <Loader />
            : loginState
              ? <DashboardRoutes />
              : <LandingRoutes />
          }
          <Tostify />
        </Suspense>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;